import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Tooltip from "@mui/material/Tooltip";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { getBillDetailsByUUID, getAllBillRecords, logBillHistory, uploadBill, getWarehouseKeyValueList, getDebitNote2 } from "../../../services/index";
import ViewPdf from "../../Common/ViewPdf";
import AddIcon from "@mui/icons-material/Add";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import PaymentIcon from "@mui/icons-material/Payment";
import { Button } from "antd";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getUploadFileList, postQualityCheckInBill } from "../../../services/Purchase/BillService";
import Select from "react-select";
import { Modal, Spinner } from "react-bootstrap";
import { getQualityParaMeterKeyValuePair } from "../../../services/Master/QualityParameterServices";
import DebitNoteView from "../debitNote/DebitNoteView";
import CreateDebitNote from "../debitNote/CreateDebitNote";

const BillView = (props) => {
    const { state } = useLocation();
    let { id } = useParams();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [tabIndex, setTabIndex] = useState(0);
    const [keys, setKeys] = useState("");
    const [values, setValues] = useState("");
    const [hsnKey, setHsnKey] = useState("");
    const [hsnVal1, setHsnVal1] = useState("");
    const [hsnVal2, setHsnVal2] = useState("");
    const [taxType, setTaxType] = useState("");
    const [orgDetail, setOrgDetail] = useState("");
    const [docName, setDocName] = useState("");
    const todaysDate = new Date();
    const [billDate, setBillDate] = useState(todaysDate.toISOString().split("T")[0]);
    const [logData, setLogData] = useState({});
    const [purchaseOrdersList, setPurchaseOrdersList] = useState([]);
    const [purchaseOrderDetail, setPurchaseOrderDetail] = useState(null);
    const [file, setFile] = useState(null);
    const [uploadedBills, setUploadedBills] = useState(null);
    const [uploadedFileList, setUploadedFileList] = useState();
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [purchaseOrdersListDetails, setPurchaseOrdersListDetails] = useState(null);
    const [wareOptions, setWareOptions] = useState(null);
    const [qualityParameterOptions, setQualityParameterOptions] = useState(null);
    const [parameterizeQualityCheck, setParameterizeQualityCheck] = useState("");
    const [selectedWarehouse, setSelectedWarehouse] = useState({
        label: "",
        value: ""
    })
    const [qualityModal, setQualityModal] = useState(false)
    const [showDebitModal, setShowDebitModal] = useState(false);
    const [isEditDebit, setIsEditDebit] = useState(false);
    const [existingDebitData, setExistingDebitData] = useState(null);
    const [itemsList, setItemList] = useState([])
    let navigate = useNavigate();
    const physicalQualityOptions = [
        { label: "Accept", value: "Accept" },
        { label: "Reject", value: "Reject" },
        { label: "Hold", value: "Hold" },
        { label: "Pending", value: "Pending" },
    ]

    const handleEdit = (orderUuid) => {
        navigate("/bills/" + orderUuid + "/edit");
    };
    const [updating, setUpdating] = useState(false)
    const [rows, setRows] = useState([]);
    const getAllPurchaseOrders = () => {
        let list_data = {
            page: index,
            size: 15,
            search: filterText,
            uuid2: selectedWarehouse.value
        };
        getAllBillRecords(list_data).then((res) => {
            if (res.errorCode === 0) {
                if (index === 0) {
                    setPurchaseOrdersList(res.responsePacket.data);
                    setRows(res.responsePacket.data);
                } else {
                    const purchaseOrdersListClone = [...purchaseOrdersList, ...res.responsePacket.data];
                    setPurchaseOrdersList(purchaseOrdersListClone);
                    setRows(purchaseOrdersListClone);
                }
                setIndex(index + 1);
                setPurchaseOrdersListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                });
            } else {
                toast(res.message);
            }
        });
    };

    const getWarehouseOptions = () => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                if (state?.warehouse) {
                    setSelectedWarehouse(state.warehouse)
                }
                else {
                    setSelectedWarehouse(options[0])
                }
                setWareOptions(options);
            }
        });
    }

    useEffect(() => {
        if (selectedWarehouse.value !== "") {
            getAllPurchaseOrders();
        }
    }, [filterText, selectedWarehouse])

    const getPurchase = (id) => {
        getBillDetailsByUUID(id).then((res) => {
            if (res.errorCode === 0) {
                let ddd = res.responsePacket;
                let d = res.responsePacket.billItemsList;
                ddd.vendorAddresses?.map((a) => {
                    if (a.addressType === "Billing") {
                        ddd.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        ddd.shipAdd = a;
                    }
                });

                let netTax = 0;
                let disTax = 0;
                let disPercent = 0;
                let disAmount = 0;
                let disSubtotal = 0;

                let sub1 = 0;
                d?.map((a) => {
                    sub1 = sub1 + a.amount;
                });


                if (Number(sub1).toFixed(2) !== Number(ddd.subTotalAmount).toFixed(2)) {
                    toast.error("subtotal mismatch");
                }

                var subtot = JSON.parse(JSON.stringify(res.responsePacket.subTotalAmount));

                if (ddd.discountTypeEnum === "Percentage") {
                    let dis = 0.01 * ddd.discountValue * subtot;
                    disPercent = ddd.discountPercent = ddd.discountValue;
                    disAmount = ddd.discountAmount = dis;

                    ddd.discountSubTotal = subtot - ddd.discountAmount;
                } else if (ddd.discountTypeEnum === "Amount") {
                    let dis = (100 * ddd.discountValue) / subtot;
                    disPercent = ddd.discountPercent = dis;
                    disAmount = ddd.discountAmount = ddd.discountValue;
                    ddd.discountSubTotal = subtot - ddd.discountAmount;
                } else {
                    ddd.discountSubTotal = subtot;
                    ddd.discountPercent = 0;
                    ddd.discountAmount = 0;
                }
                d?.map((a) => {
                    a.taxBean = a.taxes;
                    a.taxBean.newTax = a.taxBean?.taxType + a.taxBean.rate.toString();
                    a.taxBean.disAmount = a.taxBean.amount;
                    a.disItemAmount = a.amount;
                    netTax += a.taxBean.amount;
                    disTax += a.taxBean.disAmount;
                    disSubtotal += a.taxBean.disItemAmount;
                });

                let obj = {};
                for (let i = 0; i < d.length; i++) {
                    if (obj[d[i].taxBean.newTax]) {
                        obj[d[i].taxBean.newTax] += d[i].taxBean.disAmount;
                    } else {
                        obj[d[i].taxBean.newTax] = d[i].taxBean.disAmount;
                    }
                }
                let s1 = ddd?.shippingChargeTaxTitle?.split(" ")[0];
                let s2 = ddd?.shippingChargeTaxTitle?.split(" ")[1];

                let shipTaxTitle = (ddd.shippingChargeTaxTitle2 = s1 + s2);

                setKeys(Object.keys(obj));
                setValues(Object.values(obj));
                let arr = [];
                Object.keys(obj)?.map((a, i) => {
                    Object.values(obj)?.map((b, j) => {
                        if (i === j) {
                            return arr.push({ tax: a, value: b });
                        }
                    });
                });

                let z = JSON.parse(JSON.stringify(d));

                z?.map((a) => {
                    a.newHsn = a.hsnSac.toString() + "_" + a.taxBean.newTax;
                });

                let obj2 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj2[z[i].newHsn]) {
                        obj2[z[i].newHsn] += z[i].taxBean.disAmount;
                    } else {
                        obj2[z[i].newHsn] = z[i].taxBean.disAmount;
                    }
                }

                let obj3 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj3[z[i].newHsn]) {
                        obj3[z[i].newHsn] += z[i].disItemAmount;
                    } else {
                        obj3[z[i].newHsn] = z[i].disItemAmount;
                    }
                }

                setHsnKey(Object.keys(obj2));
                setHsnVal1(Object.values(obj2));
                setHsnVal2(Object.values(obj3));

                let t2 = ddd.totalAmount.toFixed(2).toString()?.split(".")[1];
                if (t2 > 49) {
                    ddd.totalAmount += 1;
                    let a = 100 - t2;
                    ddd.rounding = "+0." + a;
                } else {
                    ddd.rounding = "-0." + t2;
                }

                ddd.netTax = netTax;
                ddd.disTax = disTax;
                ddd.shipValue = ddd.shippingCharges / (1 + ddd.shippingChargeTaxRate * 0.01);
                let zx = (ddd.shipTaxValue = ddd.shippingCharges - ddd.shipValue);

                arr?.map((a) => {
                    if (a.tax === shipTaxTitle) {
                        a.value = a.value + zx;
                    }
                });

                ddd.taxDetail = arr;
                logBillHistory(res.responsePacket.billNo).then((res) => {
                    if (res.errorCode === 0) {
                        const d = res.responsePacket;
                        setLogData(d);
                    } else {
                        toast(res.message);
                    }
                });

                let localDate = new Date(ddd.billDate).toISOString().replace(/T.*/, "").split("-").reverse().join("-");
                let _invoiceDate = new Date(ddd.invoiceDate).toISOString().replace(/T.*/, "").split("-").reverse().join("-");

                ddd.billDate = localDate;
                ddd.invoiceDate = _invoiceDate;
                setPurchaseOrderDetail(ddd);
                let org = JSON.parse(localStorage.getItem("orgDetail"));
                setOrgDetail(org);
                if (org?.beanAddress?.state === undefined) {
                    alert("logged In user's organization address not found ");
                }

                let gst12cust = res.responsePacket.vendorGst.substring(0, 2);
                let gst12org = org.gstNumber.substring(0, 2);
                if (gst12cust === gst12org) {
                    setTaxType("intra");
                } else {
                    setTaxType("inter");
                }
            } else {
                toast(res.message);
            }
        });
    };

    useEffect(() => {
        if (purchaseOrderDetail?.billItemsList) {

            let data = [...purchaseOrderDetail?.billItemsList].map((e) => {
                return { ...e, parameterizeQualityCheck: JSON.parse(e.parameterizeQualityCheck || "[]"), physicalQualityCheckEnum: physicalQualityOptions.find((opt) => opt.value == e.physicalQualityCheckEnum) }
            })

            setItemList(data)
        }
    }, [purchaseOrderDetail])

    const getUploadedBills = (id) => {
        // getBillDetailsByUUID(id).then((res) => {
        // if (res.errorCode === 0) {
        //     setUploadedBills(response.responsePacket)
        // } else {
        //     toast(res.message);
        // }
        // });
    };

    const getUploadedFileList = (id) => {
        getUploadFileList(id).then((res) => {
            if (res.errorCode === 0) {
                setUploadedFileList(res.responsePacket);
            } else {
                toast(res.message);
            }
        });
    };

    useEffect(() => {
        getWarehouseOptions();
    }, [])
    useEffect(() => {
        getQualityParaMeterKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    key: d.key,
                    value: d.key,
                    label: d.value,
                })) || [];

                setQualityParameterOptions(options);
            } else {
                toast(res);
            }

        });
    }, [qualityModal, id]);


    useEffect(() => {
        getPurchase(id);
        getUploadedBills(id);
        getUploadedFileList(id);
    }, [id]);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);

        // const result = rows.filter((a) => {
        //     return (
        //         searchForMatch(a.vendorTitle, e.target.value) ||
        //         searchForMatch(a.purchaseOrderNo, e.target.value) ||
        //         searchForMatch(a.warehouseTitle, e.target.value) ||
        //         searchForMatch(a.purchaseOrderDate, e.target.value) ||
        //         searchForMatch(a.priceListTitle, e.target.value) ||
        //         searchForMatch(a.billDate, e.target.value)
        //     );
        // });
        // setPurchaseOrdersList(result);
    };

    const filterOptions = [
        { value: "isInvoiced", label: "isInvoiced" },
        { value: "isPaid", label: "isPaid" },
        { value: "isPacked", label: "isPacked" },
        { value: "allOrders", label: "allOrders" },
    ];

    const handleFilter = (e) => {
        // if (e.value === "isPaid") {
        //     var arr1 = rows.filter((data) => data.isPaid);
        //     setPurchaseOrdersList(arr1);
        // }
        // if (e.value === "isInvoiced") {
        //     var arr2 = rows.filter((data) => data.isInvoiced);
        //     setPurchaseOrdersList(arr2);
        // }
        // if (e.value === "isPacked") {
        //     var arr3 = rows.filter((data) => data.isPacked);
        //     setPurchaseOrdersList(arr3);
        // }
        // if (e.value === "allOrders") {
        //     var arr3 = rows.filter((data) => data.orderNo);
        //     setPurchaseOrdersList(arr3);
        // }
        setIndex(0);
        setSelectedWarehouse(e)
    };

    const handleFileRead = async (event) => {
        const fileTemp = event.target.files[0];
        setFile(fileTemp);

        // const base64 = await convertBase64(fileTemp);
        // const base = base64.split(",")[1];
    };
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };


    const handleSubmitBill = () => {
        if (!file) {
            toast("Please Import Document");
            return;
        }

        let formData = new FormData();

        formData.append("file", file);
        formData.append("billId", purchaseOrderDetail?.recordId);
        // formData.append("billNo", purchaseOrderDetail?.billNo);
        // formData.append("purchaseOrderNo", purchaseOrderDetail?.purchaseOrderNo);
        // formData.append("fileName", docName ? docName : purchaseOrderDetail?.billNo);
        // formData.append("date", billDate ? billDate : new Date());

        // const obj = {
        //     billId: purchaseOrderDetail?.recordId,
        //     billNo: purchaseOrderDetail?.billNo,
        //     purchaseOrderNo: purchaseOrderDetail?.purchaseOrderNo,
        //     file: JSON.stringify(formData),
        //     fileName: docName ? docName : purchaseOrderDetail?.billNo,
        //     date: billDate ? billDate : new Date(),
        // };

        uploadBill(formData).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
                setDocName("");
                setFile("");
                setBillDate("");
            } else {
                toast(res.message);
            }
        });
    };

    const openFileInNewTab = (fileUrl) => {
        window.open(fileUrl);
    };

    const downloadFile = (fileUrl) => {
        // using Java Script method to get PDF file
        fetch(fileUrl).then((response) => {
            response.blob().then((blob) => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "SamplePDF.pdf";
                alink.click();
            });
        });
    };

    const handleQualityCheck = (data) => {
        setUpdating(data.recordId)
        const payload = {
            qualityCheckComment: data?.qualityCheckComment,
            physicalQualityCheckEnum: data?.physicalQualityCheckEnum?.value,
            parameterizeQualityCheck: JSON.stringify(data.parameterizeQualityCheck)
        }
        postQualityCheckInBill(data.recordId, payload).then((res) => {
        }).catch((err) => {
            console.error("err", err)
        })
            .finally(() => {
                getPurchase(id)
                setUpdating(false)
            })
    }
    const handleDebitModal = () => {
        if (!purchaseOrderDetail || !purchaseOrderDetail.billNo) {
            toast.error("Please select a bill first");
            return;
        }
        getDebitNote2(purchaseOrderDetail.billNo).then((res) => {
            if (res.errorCode === 0 && res.responsePacket) {
                setIsEditDebit(true);
                setExistingDebitData(res.responsePacket);
            } else {
                setIsEditDebit(false);
                setExistingDebitData(null);
            }
            setShowDebitModal(true);
        }).catch((err) => {
            console.error("Error in handleDebitModal:", err);
            setIsEditDebit(false);
            setExistingDebitData(null);
            setShowDebitModal(true);
        });
    };



    return (
        <>
            <div className="list-column column d-print-none" style={{ width: "300px" }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Button
                                className="newListBtn"
                                onClick={() =>
                                    navigate(`/DirectBill`, {
                                        state: { directBill: true },
                                    })
                                }
                            >
                                <AddIcon />
                            </Button>
                            <div className="listFilter">
                                <Select value={selectedWarehouse} options={wareOptions} onChange={handleFilter} />
                            </div>
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="scroll-y fill body scrollbox list-body">
                    <div className="table-responsive overflow-initial ">
                        <table id="ember7912" className="table zi-table table-hover ember-view header-fixed">
                            {purchaseOrdersList && purchaseOrdersList.length > 0 ?
                                <tbody>
                                    {purchaseOrdersList?.map((d, i) => (
                                        <tr key={i} className={`listTr ${id === d.recordId ? "activeRecord" : ""}`}>
                                            <td>
                                                <Link to={`/bills/${d.recordId}`} className={`${id === d.recordId ? "text-primary" : "text-grey"}`}>
                                                    <span className="titleTr">{d.vendorTitle}</span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.billNo}</span>
                                                        <span>₹ {Number(d?.amount).toFixed(2)}</span>
                                                        <span>{d.billDate}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        purchaseOrdersListDetails &&
                                        purchaseOrdersListDetails?.recordsTotal > purchaseOrdersList.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllPurchaseOrders}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )
                                    }
                                </tbody> : <div className="my-3 text-black text-center">
                                    No Data Available!
                                </div>}
                        </table>
                    </div>
                </div>
            </div>
            <div className="column content-column" style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">
                    <div className="listTopHeading d-flex align-items-center">
                        <div className="btn-toolbar over-flow text-muted font-xlarge">
                            <span> {purchaseOrderDetail?.billNo}</span> &nbsp;&nbsp;
                        </div>
                        <div className="cursor-pointer text-primary font-size-15" onClick={() => navigate(`/purchase/${purchaseOrderDetail?.purchaseOrderId}`)}>
                            ( {purchaseOrderDetail?.purchaseOrderNo} )
                        </div>
                    </div>
                    <a className="over-flow header-title text-uppercase" style={{ fontSize: "x-large" }}>
                        &nbsp;
                    </a>
                    <div className="btn-toolbar d-flex justify-content-end align-items-center">
                        <div>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={() => setQualityModal(true)}>
                                Quality Check
                            </button>
                        </div>
                        <div>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={handlePrint}>
                                <LocalPrintshopOutlinedIcon />
                            </button>
                        </div>
                        <div>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={handleDebitModal}>
                                Debit Note
                            </button>
                        </div>
                        {purchaseOrderDetail?.isPaid ? (
                            <></>
                        ) : (
                            <>
                                <button
                                    className="tooltip-container ember-view btn btn-primary"
                                    onClick={() => navigate("/purchasePayment/" + purchaseOrderDetail.recordId, { state: { id: purchaseOrderDetail.recordId } })}
                                    type="button"
                                >
                                    <Tooltip title="pay">
                                        <PaymentIcon />
                                    </Tooltip>
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className="upperTabs">
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                        <Tab>Upload Invoice</Tab>
                    </TabList>
                    <TabPanel>
                        {/* {purchaseOrderDetail && purchaseOrderDetail && orgDetail && orgDetail ? ( */}
                        {purchaseOrderDetail && orgDetail ? (
                            <ViewPdf
                                orderDetail={purchaseOrderDetail}
                                itemList={purchaseOrderDetail.itemsList ? purchaseOrderDetail.itemsList : purchaseOrderDetail.billItemsList}
                                address={purchaseOrderDetail.vendorAddresses}
                                orgDetail={orgDetail}
                                taxType={taxType}
                                componentRef={componentRef}
                                pdfType={"bill"}
                                keys={keys}
                                values={values}
                                handlePrint={handlePrint}
                                hsnKey={hsnKey}
                                hsnVal1={hsnVal1}
                                hsnVal2={hsnVal2}
                                discountAmt={purchaseOrderDetail.discountAmt}
                            />
                        ) : (
                            <></>
                        )}
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <tr>
                                        <td>Date</td>
                                        <td>Changes</td>
                                    </tr>
                                )}
                                {logData.length >= 1 &&
                                    logData?.map((history, i) => {
                                        return (
                                            <div key={history.billId}>
                                                <tr>
                                                    <td style={{ verticalAlign: "top", width: "90px" }}>
                                                        {history?.billDate?.substring(0, 10)}
                                                        :&nbsp;&nbsp;
                                                        <br />
                                                        Time:
                                                        {history?.billDate?.split("T")[1]?.substring(0, 5)}
                                                    </td>

                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                        {/* {history?.message.split("\n")?.map((b, i) => (
                                                    <tr>{b.includes("\t") ? <div style={{ marginLeft: "20px" }}>{b}</div> : b.includes("\t\t") ? <div style={{ marginLeft: "40px" }}>{b}</div> : b}</tr>
                                                ))} */}
                                                    </td>
                                                </tr>
                                                <hr />
                                            </div>
                                        );
                                    })}
                            </table>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                            <div className="card">
                                <div className="card-body border-0">
                                    <div className="row">
                                        <div className="col-6">
                                            <span className="mr-2">GRN No.</span>
                                            <span className="text-primary font-weight-bold">{purchaseOrderDetail?.billNo}</span>
                                        </div>
                                        <div className="col-6">
                                            <input
                                                autoComplete="off"
                                                className="ember-text-field ember-view form-control "
                                                id="originalFileName"
                                                type="file"
                                                inputProps={{
                                                    accept: "image/*, .xlsx, .xls, .csv, .pdf, .pptx, .pptm, .ppt",
                                                }}
                                                required
                                                label="Document"
                                                name="originalFileName"
                                                onChange={(e) => handleFileRead(e)}
                                                size="small"
                                                variant="standard"
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end mt-2">
                                        <button className="btn btn-primary ember-view" type="button" onClick={handleSubmitBill}>
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card mt-4">
                                <div className="card-body border-0">
                                    {uploadedFileList &&
                                        (uploadedFileList.length > 0 ? (
                                            <table className="table customTable">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "50%" }}>File Name</th>
                                                        <th>Uploaded By</th>
                                                        <th>Uploaded On</th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {uploadedFileList.map((file, i) => (
                                                        <tr key={i}>
                                                            <td>{file.fileName}</td>
                                                            <td>{file.userName}</td>
                                                            <td>{file.uploadDate}</td>
                                                            <td className="text-center">
                                                                <span onClick={() => openFileInNewTab(file.fileUrl)} target="_blank" download className="successBtn mr-2">
                                                                    <VisibilityIcon />
                                                                </span>
                                                                {/* <a href={file.fileUrl} target="_blank" download={`Bill - ${purchaseOrderDetail?.billNo}`} className="successBtn mr-2">
                                                                    <DownloadIcon />
                                                                </a> */}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <>No Invoice Uploaded</>
                                        ))}
                                </div>
                            </div>
                            {/* <div className="card mt-4">
                                <div className="card-body border-0">
                                    {uploadedBills &&
                                        (uploadedBills.length > 0 ? (
                                            <table className="customTable">
                                                <thead>
                                                    <tr>
                                                        <th>Bill Date</th>
                                                        <th>Document Name</th>
                                                        <th>Download</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {uploadedBills.map((bill, i) => (
                                                        <tr key={i}>
                                                            <td>{bill.date}</td>
                                                            <td>{bill.name}</td>
                                                            <td>
                                                                <a href={bill.url} target="_blank" download className="successBtn mr-2">
                                                                    <DownloadIcon /> E-Invoice
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <>No Invoice Uploaded</>
                                        ))}
                                </div>
                            </div> */}
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
            <Modal show={qualityModal} onHide={() => setQualityModal(false)} size="xl">
                <Modal.Body className="standardTable batchViewTable" style={{ minHeight: "150px" }}>
                    {/* {batchDetails?.batchItemsList && (
                        <div className="col-5">
                            <h2 className="font-size-18 font-weight-bold">
                                {batchDetails?.batchItemsList[0]?.batchNo}{" "}
                                {batchDetails && ` (${batchDetails?.batchItemsList[0]?.batchName})`}
                            </h2>
                        </div>
                    )} */}
                    {true && (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Physical Quality</th>
                                    <th>Rate</th>
                                    <th>Amount</th>
                                    <th>Comment</th>
                                    <th>Quality Parameter</th>
                                    <th>Submit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsList?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.itemTitle}</td>
                                        <td>{item.quantity}</td>
                                        <td>
                                            <Select
                                                value={item?.physicalQualityCheckEnum}
                                                options={physicalQualityOptions}
                                                onChange={(e) => {
                                                    let data = [...itemsList]
                                                    data[index].physicalQualityCheckEnum = e
                                                    setItemList(data)
                                                    // setPhysicalQualityCheckEnum(e);
                                                }}
                                            /></td>
                                        <td>{item.rate}</td>
                                        <td>{item.amount}</td>
                                        <td>
                                            <input
                                                className="ember-text-field ember-view"
                                                type="text"
                                                name="qualityCheckComment"

                                                onChange={(e) => {
                                                    let data = [...itemsList]
                                                    data[index].qualityCheckComment = e.target.value
                                                    setItemList(data)
                                                }}
                                                value={item?.qualityCheckComment}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        marginTop: '0px !important',
                                                    }),
                                                }}
                                                className="ember-text-field ember-view "
                                                options={qualityParameterOptions}
                                                value={item?.parameterizeQualityCheck}
                                                onChange={(e) => {
                                                    let data = [...itemsList]
                                                    data[index].parameterizeQualityCheck = e
                                                    setItemList(data)
                                                }}
                                                isMulti
                                            />
                                        </td>
                                        <td>
                                            <Button disabled={!item?.qualityCheckComment || !item?.physicalQualityCheckEnum?.value || item?.parameterizeQualityCheck?.length == 0} onClick={() => {
                                                handleQualityCheck(item)
                                            }}
                                                className="tooltip-container ember-view btn btn-primary print-btn">
                                                {updating == item.recordId ? <Spinner /> : "Update"}</Button></td>
                                    </tr>
                                ))

                                }
                            </tbody>
                        </table>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => setQualityModal(false)}
                        className="tooltip-container ember-view btn btn-primary print-btn">
                        Close</Button>

                </Modal.Footer>
            </Modal>
            <Toaster />
            {showDebitModal && (
                <CreateDebitNote
                    key={`debit_${purchaseOrderDetail?.recordId}_${isEditDebit}`}
                    show={showDebitModal}
                    onHide={() => {
                        setShowDebitModal(false);
                        setIsEditDebit(false);
                        setExistingDebitData(null);
                    }}
                    billRecordId={purchaseOrderDetail?.recordId}
                    billNo={purchaseOrderDetail?.billNo}
                    isEdit={isEditDebit}
                    exData={existingDebitData}
                />
            )}
        </>
    );
};

export default BillView;
